import React from "react";

const ProgressBar = ({ steps, activeStep, completedStep }) => {
  const lastStepIndex = Math.max(steps.length - 1, 1);
  const completedPosition = Math.max(completedStep, activeStep - 1);
  const progressPercent = Math.min(100, Math.max(0, (completedPosition / lastStepIndex) * 100));

  return (
    <nav aria-label="Order progress" className="mx-auto w-full max-w-[760px] pb-1">
      <div className="relative">
        <div aria-hidden="true" className="absolute left-[12.5%] right-[12.5%] top-[13px] h-[3px] overflow-hidden rounded-full bg-soft-gray">
          <div className="h-full rounded-full bg-blue-shades transition-[width] duration-500 ease-out" style={{ width: `${progressPercent}%` }} />
        </div>

        <ol className="relative grid grid-cols-4">
          {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber <= completedStep;
          const isActive = activeStep === stepNumber;

          return (
            <li key={index} aria-current={isActive ? "step" : undefined} className="relative z-[1] flex min-w-0 flex-col items-center px-1">
              <span className={`flex h-[28px] w-[28px] items-center justify-center rounded-full border text-[11px] font-bold shadow-sm transition-all duration-300 ${isCompleted ? "border-blue-shades bg-blue-shades text-white" : isActive ? "border-blue-shades bg-white text-blue-shades ring-4 ring-blue-100" : "border-medium-gray bg-white text-gray"}`}>
                {isCompleted ? (
                  <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="h-4 w-4">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                ) : stepNumber}
                <span className="sr-only">{isCompleted ? "Completed" : isActive ? "Current step" : "Upcoming step"}</span>
              </span>
              <span className={`mt-1.5 hidden max-w-[120px] truncate text-center font-inter text-[10px] leading-[14px] sm:block ${isActive ? "font-semibold text-blue-shades" : isCompleted ? "font-medium text-secondary" : "text-gray"}`} title={step.fullLabel}>
                {step.fullLabel}
              </span>
              <span className={`mt-1.5 block max-w-[72px] truncate text-center font-inter text-[10px] leading-[14px] sm:hidden ${isActive ? "font-semibold text-blue-shades" : isCompleted ? "font-medium text-secondary" : "text-gray"}`} title={step.fullLabel}>
                {step.shortLabel}
              </span>
            </li>
          );
          })}
        </ol>
      </div>
    </nav>
  );
};

export default ProgressBar;
